module.exports = __webpack_public_path__ + "assets/svg/UI/map-pin-location-gray-af5b99.svg";